import React from 'react';
import './sec3.css'
import pic19 from '../assets/pic19.png'
import pic20 from '../assets/pic20.png'
import pic21 from '../assets/pic21.png'
import pic22 from '../assets/pic22.png'
import pic23 from '../assets/pic23.png'
import pic24 from '../assets/pic24.png'
import { useState } from 'react';

const Sec3 = () => {

          const [inView, setInView] = useState(false);
        
        
          const handleScroll = () => {
            const section = document.querySelector('.sec3');
            if (!section) return;
            const rect = section.getBoundingClientRect();
            const isVisible = rect.top < window.innerHeight && rect.bottom > 0;
            if (isVisible !== inView) setInView(isVisible);
          };
        
        
        window.addEventListener('scroll', handleScroll);
        window.addEventListener('load', handleScroll);



    return ( 
        <section className='sec3'>
                <div className='part1-sec3' ></div>
                <article className='part2-sec3'>
                    <article className='part2-sec3-2'>
                        <article className='box1-sec3'>
                            <article className='container-header-sec3'>



                                <h1 className='header-sec3'>Passion</h1>
                                <div className='rect-yellow-sec3'></div>
                            </article>
                            <p  className={`para1-sec3 ${inView ? 'animate' : ''}`}>Coco Chanel was passionate about
                                 transforming women’s fashion. She
                                  introduced simple, elegant designs
                                   that replaced uncomfortable styles,
                                    helping women feel free and confident.
                                     Her creativity led to timeless pieces
                                      that are still admired today.</p>
                        </article>
                        
                    <figure className='container-imgs-sec3'>
                        <img className='pic1-sec3' src={pic19} alt='pic'></img>
                        <img  className={`pic2-sec3 ${inView ? 'animate' : ''}`} src={pic20} alt='pic'></img>
                        <img className={`pic3-sec3 ${inView ? 'animate' : ''}`} src={pic21} alt='pic'></img>
                         <img className='pic4-sec3' src={pic22} alt='pic'></img>
                           <img className='pic5-sec3' src={pic23} alt='pic'></img>
                         <img className='pic6-sec3' src={pic24} alt='pic'></img>

                    </figure>


                        <article className='box2-sec3'>
                            <article className='container-header-sec3'>
                                <h1 className='header2-sec3'>Resilience</h1>

                                <div className='rect2-yellow-sec3'></div>
                                <div className='rect3-yellow-sec3'></div>
                            </article>
                            <p className={`para2-sec3 ${inView ? 'animate' : ''}`}>Despite growing up in poverty and facing many challenges, Chanel worked hard to build her fashion empire. Her determination and strong will allowed her to overcome obstacles and become one of the most influential designers in history.</p>
                        </article>









                    
                    </article>












                </article>
        </section>
     );
}
 
export default Sec3;